@if (searchService.results().length) {
  <div
    class="company-search-results__list"
    #list
    scrollingList
    (scrollEndEvent)="onScrollEnd()"
  >
    <company-tree
      [searchResults]="searchService.results()"
      [scrollRoot]="list"
      (selectCompany)="selectCompany.emit($event)"
    ></company-tree>
    <!-- Inside the list, which is the scroll container: a sibling outside it
         would never reach the end of the results. -->
    @if (loadingMore()) {
      <div
        class="company-search-results__loading-more"
        role="none"
        aria-hidden="true"
      >
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    }
  </div>
}
@if (errorMessage()) {
  <div class="company-search-results__error" role="alert">
    <strong>{{ errorMessage() }}</strong>
    <button
      type="button"
      class="company-search-results__retry"
      (click)="onRetry()"
    >
      Retry
    </button>
  </div>
}
<!-- Mounted rather than wrapped in `@if`: the copy replaces a list the user was
     watching, and a live region inserted at that moment is not reliably
     announced. -->
<div
  class="company-search-results__empty"
  [class.company-search-results__empty--shown]="showEmptyState()"
  role="status"
>
  @if (showEmptyState()) {
    <div class="company-search-results__empty-art" aria-hidden="true">
      <img
        src="/images/no-search-results.svg"
        alt=""
        aria-hidden="true"
        width="48"
        height="48"
      />
    </div>
    <p class="company-search-results__empty-copy">No search results found</p>
  }
</div>
